import { logError } from '@ptek/client-logger';
import { apiRouter } from '../config/api';

export interface CreateContestEntryResponse {
  success: boolean;
  data?: {
    userId?: string;
    sessionId?: string;
    brand?: string;
    timezone?: string;
    entryDate?: string;
    earnedAt?: string;
    ticketNumber?: string;
    created: boolean;
    eligible?: boolean;
    reason?: string;
  };
  error?: string;
}

export interface ContestEntriesStatus {
  entriesEarned: number;
  todayEntryEarned: boolean;
}

export class ContestEntriesClient {
  private async makeApiCall(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<unknown> {
    return apiRouter.makeApiCall(endpoint, options);
  }

  async getEntries(): Promise<ContestEntriesStatus> {
    try {
      const response = await this.makeApiCall('/api/v1/contest/entries', {
        method: 'GET',
      });

      return response as ContestEntriesStatus;
    } catch (error) {
      logError(
        'ContestEntriesClient',
        'Failed to fetch contest entries:',
        error
      );
      throw error;
    }
  }

  async createContestEntry(
    sessionId?: string
  ): Promise<CreateContestEntryResponse> {
    try {
      const response = await this.makeApiCall('/api/v1/contest/entries', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sessionId,
        }),
      });

      return response as CreateContestEntryResponse;
    } catch (error) {
      logError(
        'ContestEntriesClient',
        'Failed to create contest entry:',
        error
      );
      throw error;
    }
  }
}

export const contestEntriesClient = new ContestEntriesClient();
